export const TenantKey: string = 'Tenant';
export const TenantHeaderName: string = 'X-Roc-Tenant';
export const CurrentTenantIdQueryString: string = 'tenantId';
export const VHOST_SETTING: string = 'roc-features-appsettings-affiliateddistributors-vhost';
